import React from 'react';
import '../style/appScreenshots.css';

const AppScreenshots = () => {
  const screenshotUrls = [
    'https://lh3.googleusercontent.com/SxOkw3FetmkiuC5LdwQ9qRI3s2KNfDQsPhCdt8ADi9BflVOAyVJ6UwWf5ip_K2u7c7U',
    'https://lh3.googleusercontent.com/TUP27MSY1jLaFHNFO1Th_QSQG3lfRJXJv6JFSPmEhG6mm9xRjlpzT4ypsDhiyV_oWc8',
    'https://lh3.googleusercontent.com/ujJo1VRlB5CcwKBn2n6q-piI-CYSC_rKTgtfXrIMJJt8BF89m1YmxhZNhVYUKE-xSQ'
  ];

  return (
    <div className="screenshots-container">
      {screenshotUrls.map((url, index) => (
        <img
          key={index}
          src={url}
          alt={`Screenshot ${index + 1}`}
          className="screenshot"
        />
      ))}
    </div>
  );
};

export default AppScreenshots;
